import { render, staticRenderFns } from "./BankInformationForm.vue?vue&type=template&id=53ede0b1&scoped=true"
import script from "./BankInformationForm.vue?vue&type=script&lang=js"
export * from "./BankInformationForm.vue?vue&type=script&lang=js"
import style0 from "./BankInformationForm.vue?vue&type=style&index=0&id=53ede0b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ede0b1",
  null
  
)

export default component.exports